import { render, staticRenderFns } from "./modalList.vue?vue&type=template&id=3f4ab854&"
import script from "./modalList.vue?vue&type=script&lang=js&"
export * from "./modalList.vue?vue&type=script&lang=js&"
import style0 from "./modalList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports